export var csrfToken = "requestverificationtoken";
export function csrfTokenValue() {
    var _a;
    return (_a = document
        .querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.attributes.getNamedItem("content").value;
}
